import { render, staticRenderFns } from "./CustomQuestionsModal.vue?vue&type=template&id=5ead652e&scoped=true"
import script from "./CustomQuestionsModal.vue?vue&type=script&lang=ts"
export * from "./CustomQuestionsModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomQuestionsModal.vue?vue&type=style&index=0&id=5ead652e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead652e",
  null
  
)

export default component.exports